import { Space } from './interfaces'

export const space: Space = {
  none: 0,
  xxxs: 4,
  xxs: 8,
  xs: 12,
  s: 16,
  m: 24,
  l: 32,
  xl: 40,
  xxl: 48,
  xxxl: 64,
  xxxxl: 80,
}
